import { getSupabaseFunctionUrl } from '@/lib/supabase';

export interface MotionOption {
  id: 'morph' | 'dynamic' | 'cinematic';
  label: string;
  description: string;
  icon: string;
  badge?: string;
}

export interface AspectOption {
  id: 'vertical' | 'square' | 'landscape';
  ratio: string;
  label: string;
  icon: string;
  recommended?: boolean;
  description: string;
}

export interface VideoAdState {
  status: 'idle' | 'pending' | 'processing' | 'completed' | 'failed';
  taskId: string | null;
  videoUrl: string | null;
  audioUrl: string | null;
  voiceoverScript: string | null;
  error: string | null;
  progress: number | null;
}

export const VIDEO_AD_GENERATE_CREDITS = 50;
export const VIDEO_AD_REGENERATE_CREDITS = 40;
export const VIDEO_AD_VOICEOVER_CREDITS = 10;
export const VIDEO_AD_SOUND_EFFECT_CREDITS = 10;
export const VIDEO_AD_MUSIC_CREDITS = 20;
export type VideoAdDuration = 5 | 10;
export const VIDEO_AD_DEFAULT_DURATION: VideoAdDuration = 5;
export const VIDEO_AD_DURATION = VIDEO_AD_DEFAULT_DURATION;
export const VIDEO_AD_EDGE_URL = getSupabaseFunctionUrl('generate-video-ad');

export function getVideoAdCreditCost(duration: VideoAdDuration): number {
  return duration === 10 ? 100 : VIDEO_AD_GENERATE_CREDITS;
}

export const motionOptions: MotionOption[] = [
  {
    id: 'morph',
    label: 'Morph & Transform',
    description: 'Elements evolve and transform — scene upgrades, product enhancements, and before-to-after progressions with a strong visual hook',
    icon: 'ri-magic-line',
    badge: 'New',
  },
  {
    id: 'dynamic',
    label: 'Dynamic Motion',
    description: 'Camera movement, parallax depth, and light transitions — optimised for Facebook and Instagram ad performance',
    icon: 'ri-flashlight-line',
    badge: 'Popular',
  },
  {
    id: 'cinematic',
    label: 'Cinematic Motion',
    description: 'Dramatic camera movement, cinematic lighting, and premium atmosphere — feels like a high-end brand advertisement',
    icon: 'ri-movie-line',
    badge: 'Premium',
  },
];

export const aspectOptions: AspectOption[] = [
  {
    id: 'vertical',
    ratio: '9:16',
    label: 'Vertical',
    icon: 'ri-smartphone-line',
    recommended: true,
    description: 'Stories, Reels & TikTok',
  },
  {
    id: 'square',
    ratio: '1:1',
    label: 'Square',
    icon: 'ri-square-line',
    description: 'Feed posts & carousel',
  },
  {
    id: 'landscape',
    ratio: '16:9',
    label: 'Landscape',
    icon: 'ri-tv-2-line',
    description: 'YouTube & display ads',
  },
];
